import { render, staticRenderFns } from "./AIPrincipalTokens.vue?vue&type=template&id=e7a42b00&scoped=true&"
import script from "./AIPrincipalTokens.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AIPrincipalTokens.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AIPrincipalTokens.vue?vue&type=style&index=0&id=e7a42b00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7a42b00",
  null
  
)

export default component.exports